import React, { useState } from 'react'
import './Home.css'
import Header from './header/Header'
import Footer from './footer/Footer'
import Imgslider from './imgslider/Imgslider'
import ProductCard from './Product'
import Servicecard from './serviceCard/Servicecard'
import Review from './Review'
import Modal from './Modal/Modal'
import Userreview from './Review/Userreview'
function Home() {
    const products =[
        {id:1,plan:"Beginners Plan 1",speed:40,price:425,op1:"WiFi Router Free To Use"},
        {id:4,plan:"Binging Plan 2",speed:100,price:525, op1:"5Ghz Dual Band Router Free To Use"},
        {id:3,plan:"WFH Plan",speed:150,price:625, op1:"5Ghz Dual Band Router Free To Use"},
      ]
      const product2=[
        {id:2,plan:"Family Plan 1",speed:200,price:725, op1:"5Ghz Dual Band Router Free To Use"},
        {id:6,plan:"Family Plan 2",speed:250,price:825, op1:"5Ghz Dual Band Router Free To Use"},
        {id:5,plan:"Premium Plan",speed:300,price:925, op1:"5Ghz Dual Band Router Free To Use"},
      ]
      const attributes = [
        { label: 'Active Customers', value: 85 ,show:false,showValue:"2k"},
        { label: 'Total Clients', value: 61 ,show:false,showValue:"2.5k"},
        { label: 'Coverage Area', value: 71 ,show:true,showValue:10},
        { label: 'Years Of Experience', value: 81 ,show:true,showValue:11},
        // Add more attributes as needed
      ];

    const [showModal, setShowModal] = useState(false);
  const [productDetails, setProductDetails] = useState({});
  const handleOrderClick = (plan, speed, price) => {
    setProductDetails({ plan, speed, price });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission here
    handleCloseModal();
  };

  return (
    <div>
        <Header></Header>

    <section class="hero" id="home">
        <div class="container">
            <div class="hero-content">
                <div class="hero-text">
                    {/* <h1 class="text-gradient">Lightning Fast <br>WiFi Internet</h1> */}
                    <p>Get high-speed internet with our premium WiFi router plans. Perfect for work, gaming, streaming, and family use with speeds up to 300MBPS.</p>
                    
                </div>
                {/* <div class="hero-image">
                </div> */}
            </div>
        </div>
    </section>

    <div className="autoimg">
      <Imgslider></Imgslider>
      <div className="contact-icons">
      <a href="https://wa.me/8882797698" target="_blank" className="whatsapp-icon">
        <i className="fab fa-whatsapp"></i>
      </a>
      <a href="tel:8882797698" className="call-icon">
            <i className="fas fa-phone"></i>
      </a>
      </div>
    </div>

    <div className="foryou">
           <h1>Choose Your Perfect Plan</h1>
           <p className='span'>Select from our range of high-speed WiFi plans designed for every need and budget</p>
    </div>
    
    <div className="product">
      {products?.map((product)=>(
        <ProductCard 
        product={product}
        key={product.id}
        handleOrderClick={handleOrderClick}

        />
      ))}
      </div>
      <div className="product">
      {product2?.map((product)=>(
        <ProductCard 
        product={product}
        key={product.id}
        handleOrderClick={handleOrderClick}
        />
      ))}
      </div>

      <Modal show={showModal} handleClose={handleCloseModal} handleSubmit={handleSubmit} productDetails={productDetails} />

    <div className='review-section'>
      <div className='static'>
        <h1>Statistics</h1>
        <p>Royal Broadband benchmarks of customer experience in the Najafgarh.</p>
      </div>
      <div className='rating'>
      { attributes.map((att)=><Review  value={att.value} label={att.label} show={att.show} showValue={att.showValue}  />)
          }
          </div>
    </div>

    <div className='review-section'>
      <div className='static'>
        <h1>WHAT MAKES OUR BROADBAND SERVICE BEST?</h1>
        <p>With the power of incredibly fast internet, comes the world of incredible entertainment!</p>
      </div>
      <div className='rating'>
      
      <Servicecard 
          iconClass="fas fa-tachometer-alt" 
          title="Speed" 
          description="Royal broadband allows you to test speed before paying."
        />
        <Servicecard 
          iconClass="fas fa-shield-alt" 
          title="Security" 
          description="We update our network to keep your network protected"
        />
        <Servicecard 
          iconClass="fas fa-headset" 
          title="Support" 
          description="Our support staff happy to assist you"
        />
        <Servicecard 
          iconClass="fas fa-thumbs-up" 
          title="Reliability" 
          description="Enjoy unbeatable internet service with our fiber-optic lines"
        />
      
      </div>
    </div> 
    
    <div className='review-section'>
      <div className='static'>
      <h1>What Our Customers Say About Our WiFi Routers</h1>
      <p>Delhi's most reliable WiFi router service, trusted for seamless connectivity and exceptional support.</p>
      </div>
     
      
      <Userreview/>
      
      
    </div> 

      

        <Footer></Footer>
    </div>
  )
}

export default Home